import createQueryClient from 'openapi-react-query'
import { QueryClient } from '@tanstack/react-query'
import { client } from './client'
import type { paths } from './schema'

// Typed query/mutation hooks over the existing openapi-fetch client, so Clerk
// auth (tokenStore + authMiddleware) and the 401 retry apply to every query.
export const $api = createQueryClient<paths>(client)

// A fresh QueryClient. The app uses one singleton (main.tsx); tests make their own.
export function makeQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: true,
        retry: 1,
      },
    },
  })
}
